import { i18nMark } from 'lingui-react';

const messages = {
  cards: i18nMark('Cards'),
  list: i18nMark('List'),
  map: i18nMark('Map'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/SelectorBar/messages.js